<div class="container">
  <div class="left-container">
    <div class="curve">
      <div class="content">
        <div class="logo">
          <div class="star">
            <img src="/assets/images/star.png" loading="lazy" alt="benefits">
          </div>
          <div class="ketto-logo">
            <img src="/assets/images/ketto-logo-black.png" loading="lazy" alt="logo">
            <span class="text">Benefits</span>
          </div>
        </div>
        <div class="middle-text">
          Activate benefits now to claim when in need.
        </div>
        <div class="benefits-container">
          <div *ngFor="let item of benefits" class="benefits">
            <div class="benefits-logo" id="benefits-logo">
              <div class="benefits-logo-inner" id="benefits-logo-inner">
                <img [src]="item?.img" alt="logo" loading="lazy">
              </div>
            </div>
            <div class="below-title">{{item?.title}}</div>
            <div class="below-text">{{item?.text}}</div>
          </div>
        </div>
        <div *ngIf="isMobile" class="know-more"><a (click)="opendialog(popup)">Know More</a></div>
      </div>
    </div>
  </div>
  <div class="right-container">
    <div class="left-curve">
      <div class="rewards-content">
        <div class="logo">
          <div class="star">
            <img src="/assets/images/gift_white.png" loading="lazy" alt="benefits">
          </div>
          <div class="ketto-logo">
            <img src="/assets/images/logo_white.png" loading="lazy" alt="logo">
            <span class="text">Rewards</span>
          </div>
        </div>
        <div class="middle-text">
          Treat yourself to rewards that are exciting and healthy.
        </div>
        <div class="rewards-container">
          <div *ngFor="let item of rewards" class="rewards">
            <div class="rewards-logo">
              <div class="rewards-logo-inner">
                <img [src]="item?.img" alt="logo">
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <button (click)="claimrewards()" mat-button>Claim Benefits & Rewards</button>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #popup>
  <div class="popup">
    <div class="close">
      <button class="payment-sip-dialog-back-btn" (click)="close()" mat-button>
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="benefits-details">
      <div *ngFor="let item of benefits" class="benefits">
        <img [src]="item?.img" alt="sip">
        <div class="title">{{item?.title}}</div>
        <div class="text">{{item?.text}}</div>
      </div>
    </div>
  </div>
</ng-template>